module.exports = __webpack_public_path__ + "static/media/profile.abf71799.jpg";